import React from 'react';
import { Grid2, TextField } from '@mui/material';

function SnapchatForm({ values, setFieldValue }) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <TextField
                    fullWidth
                    label="Snapchat Pixel ID"
                    value={values.settings?.trackingId || ''}
                    onChange={(ev) =>
                        setFieldValue('settings', {
                            ...values.settings,
                            trackingId: ev.target.value,
                        })
                    }
                    placeholder="xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx"
                    helperText="Enter your Snapchat Pixel ID"
                />
            </Grid2>
        </>
    );
}

export default SnapchatForm;
